export default __webpack_public_path__ + "static/media/1.290e3940.jpeg";